import { render, staticRenderFns } from "./UOttawaLabExam.vue?vue&type=template&id=25e27d86&scoped=true&"
import script from "./UOttawaLabExam.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExam.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExam.vue?vue&type=style&index=0&id=25e27d86&prod&lang=css&"
import style1 from "./UOttawaLabExam.vue?vue&type=style&index=1&id=25e27d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e27d86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
